import React, { PureComponent } from 'react';
import { Result, Button } from 'antd';
import Auth0Service from 'shared/services/Auth0Service';

const auth0Instance = Auth0Service.getInstance();

class Error extends PureComponent {
  _logout = () => {
    localStorage.clear();
    auth0Instance.auth0Client.logout({
      client_id: process.env.AUTH0_CLIENT_ID,
      returnTo: window.location.origin,
    });
  };

  render() {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const isWrongPlatform = params.get('wrongPlatform');
    return (
      <Result
        status="403"
        title={isWrongPlatform ? 'Wrong Platform' : 'Token Expired'}
        subTitle={
          isWrongPlatform
            ? 'Mohon Maaf! Anda tidak memiliki izin untuk login ke platform ini.'
            : 'Sorry, your authorization token is expired'
        }
        extra={
          <Button type="primary" onClick={this._logout}>
            LOG OUT
          </Button>
        }
      />
    );
  }
}
export default Error;
